module.exports = __webpack_public_path__ + "static/media/Property 1=Thân thiết.76795f75.png";